import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect, useId, useState } from 'react';
import { useGetCurrentBusinessId } from '@/modules/common/hooks/useGetCurrentBusinessId.ts';
import FixedReportItem from '@/modules/admin-dashboard/components/items/FixedReportItem.tsx';
import { useGetReportsTemplatesQuery } from '@/modules/admin-dashboard/queries/reports-templates.ts';
import { EmptyListState, PageLayout, SearchField, Spinner } from 'ui';

const FixedReports = () => {
  const businessId = useGetCurrentBusinessId();
  const [searchValue, setSearchValue] = useState('');
  const containerId = useId();

  useEffect(() => {
    setSearchValue('');
  }, [businessId]);

  const { data, isLoading, fetchNextPage, hasNextPage } = useGetReportsTemplatesQuery({
    page: 1,
    page_size: 18,
    filter_by_name: searchValue,
  });
  const templates = (data?.pages || []).flatMap(({ data }) => data);

  return (
    <PageLayout title="Fixed reports">
      <div className="h-full flex flex-col gap-4">
        <div className="flex flex-wrap-reverse w-full mt-5 md:mt-0 justify-end items-center gap-3">
          <div className="flex-1 min-w-64">
            <SearchField
              placeholder="Search"
              value={searchValue}
              onChange={setSearchValue}
              allowClear
            />
          </div>
          {/*<div className="min-w-fit">*/}
          {/*  <Button onClick={handleOpenReportTemplateModal} variant="primary">*/}
          {/*    Add template*/}
          {/*  </Button>*/}
          {/*</div>*/}
        </div>

        {isLoading && (
          <div className="w-full h-full flex items-center justify-center">
            <Spinner size="lg" className="mr-0" />
          </div>
        )}
        <EmptyListState
          title="No report templates yet"
          description='Go to the report templates page and click the "Add new template" button to add a template.'
          isLoading={isLoading}
          isSearchUsed={!!searchValue}
          itemsCount={templates.length}
          classes={{ container: '!h-auto flex-1' }}
        />
        {!isLoading && !!templates.length && (
          <div id={containerId} className="overflow-y-auto">
            <InfiniteScroll
              next={fetchNextPage}
              dataLength={templates.length}
              hasMore={!!hasNextPage}
              className="w-full flex flex-col space-y-2"
              style={{ overflow: 'unset' }}
              loader={
                <div className="flex justify-center items-center h-16 w-full">
                  <Spinner size="md" variant="primary" className="mr-0" />
                </div>
              }
              scrollableTarget={containerId}
            >
              {templates.map(template => (
                <FixedReportItem template={template} key={template.id} />
              ))}
            </InfiniteScroll>
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default FixedReports;
